import * as Backbone from "backbone";
import {BaseCollection} from "./_BaseCollection";

export interface BacnetPropertyRecord {
    name: string;
    number: number;
}

var models: BacnetPropertyRecord[] = [
    {name: "Absentee Limit", number: 244},
    {name: "Accepted Modes", number: 175},
    {name: "Access Alarm Events", number: 245},
    {name: "Access Doors", number: 246},
    {name: "Access Event", number: 247},
    {name: "Access Event Authentication Factor", number: 248},
    {name: "Access Event Credential", number: 249},
    {name: "Access Event Tag", number: 322},
    {name: "Access Event Time", number: 250},
    {name: "Access Transaction Events", number: 251},
    {name: "Accompaniment", number: 252},
    {name: "Accompaniment Time", number: 253},
    {name: "Ack Required", number: 1},
    {name: "Acked Transitions", number: 0},
    {name: "Action", number: 2},
    {name: "Action Text", number: 3},
    {name: "Activation Time", number: 254},
    {name: "Active Authentication Policy", number: 255},
    {name: "Active Cov Subscriptions", number: 152},
    {name: "Active Text", number: 4},
    {name: "Active Vt Sessions", number: 5},
    {name: "Actual Shed Level", number: 212},
    {name: "Adjust Value", number: 176},
    {name: "Alarm Value", number: 6},
    {name: "Alarm Values", number: 7},
    {name: "Align Intervals", number: 193},
    {name: "All", number: 8},
    {name: "All Writes Successful", number: 9},
    {name: "Allow Group Delay Inhibit", number: 365},
    {name: "Apdu Segment Timeout", number: 10},
    {name: "Apdu Timeout", number: 11},
    {name: "Application Software Version", number: 12},
    {name: "Archive", number: 13},
    {name: "Assigned Access Rights", number: 256},
    {name: "Attempted Samples", number: 124},
    {name: "Authentication Factors", number: 257},
    {name: "Authentication Policy List", number: 258},
    {name: "Authentication Policy Names", number: 259},
    {name: "Authentication Status", number: 260},
    {name: "Authorization Exemptions", number: 364},
    {name: "Authorization Mode", number: 261},
    {name: "Auto Slave Discovery", number: 169},
    {name: "Average Value", number: 125},
    {name: "Backup And Restore State", number: 338},
    {name: "Backup Failure Timeout", number: 153},
    {name: "Backup Preparation Time", number: 339},
    {name: "Base Device Security Policy", number: 327},
    {name: "Belongs To", number: 262},
    {name: "Bias", number: 14},
    {name: "Bit Mask", number: 342},
    {name: "Bit Text", number: 343},
    {name: "Blink Warn Enable", number: 373},
    {name: "Buffer Size", number: 126},
    {name: "Change Of State Count", number: 15},
    {name: "Change Of State Time", number: 16},
    {name: "Channel Number", number: 366},
    {name: "Client Cov Increment", number: 127},
    {name: "Configuration Files", number: 154},
    {name: "Control Groups", number: 367},
    {name: "Controlled Variable Reference", number: 19},
    {name: "Controlled Variable Units", number: 20},
    {name: "Controlled Variable Value", number: 21},
    {name: "Count", number: 177},
    {name: "Count Before Change", number: 178},
    {name: "Count Change Time", number: 179},
    {name: "Cov Increment", number: 22},
    {name: "Cov Period", number: 180},
    {name: "Cov Resubscription Interval", number: 128},
    {name: "Covu Period", number: 349},
    {name: "Covu Recipients", number: 350},
    {name: "Credential Disable", number: 263},
    {name: "Credential Status", number: 264},
    {name: "Credentials", number: 265},
    {name: "Credentials In Zone", number: 266},
    {name: "Database Revision", number: 155},
    {name: "Date List", number: 23},
    {name: "Daylight Savings Status", number: 24},
    {name: "Days Remaining", number: 267},
    {name: "Deadband", number: 25},
    {name: "Default Fade Time", number: 374},
    {name: "Default Ramp Rate", number: 375},
    {name: "Default Step Increment", number: 376},
    {name: "Derivative Constant", number: 26},
    {name: "Derivative Constant Units", number: 27},
    {name: "Description", number: 28},
    {name: "Description Of Halt", number: 29},
    {name: "Device Address Binding", number: 30},
    {name: "Device Type", number: 31},
    {name: "Direct Reading", number: 156},
    {name: "Distribution Key Revision", number: 328},
    {name: "Do Not Hide", number: 329},
    {name: "Door Alarm State", number: 226},
    {name: "Door Extended Pulse Time", number: 227},
    {name: "Door Members", number: 228},
    {name: "Door Open Too Long Time", number: 229},
    {name: "Door Pulse Time", number: 230},
    {name: "Door Status", number: 231},
    {name: "Door Unlock Delay Time", number: 232},
    {name: "Duty Window", number: 213},
    {name: "Effective Period", number: 32},
    {name: "Egress Time", number: 377},
    {name: "Egress Active", number: 386},
    {name: "Elapsed Active Time", number: 33},
    {name: "Entry Points", number: 268},
    {name: "Enable", number: 133},
    {name: "Error Limit", number: 34},
    {name: "Event Algorithm Inhibit", number: 354},
    {name: "Event Algorithm Inhibit Ref", number: 355},
    {name: "Event Detection Enable", number: 353},
    {name: "Event Enable", number: 35},
    {name: "Event Message Texts", number: 351},
    {name: "Event Message Texts Config", number: 352},
    {name: "Event State", number: 36},
    {name: "Event Time Stamps", number: 130},
    {name: "Event Type", number: 37},
    {name: "Event Parameters", number: 83},
    {name: "Exception Schedule", number: 38},
    {name: "Execution Delay", number: 368},
    {name: "Exit Points", number: 269},
    {name: "Expected Shed Level", number: 214},
    {name: "Expiry Time", number: 270},
    {name: "Extended Time Enable", number: 271},
    {name: "Failed Attempt Events", number: 272},
    {name: "Failed Attempts", number: 273},
    {name: "Failed Attempts Time", number: 274},
    {name: "Fault Parameters", number: 358},
    {name: "Fault Type", number: 359},
    {name: "Fault Values", number: 39},
    {name: "Feedback Value", number: 40},
    {name: "File Access Method", number: 41},
    {name: "File Size", number: 42},
    {name: "File Type", number: 43},
    {name: "Firmware Revision", number: 44},
    {name: "Full Duty Baseline", number: 215},
    {name: "Global Identifier", number: 323},
    {name: "Group Members", number: 345},
    {name: "Group Member Names", number: 346},
    {name: "High Limit", number: 45},
    {name: "Inactive Text", number: 46},
    {name: "In Process", number: 47},
    {name: "In Progress", number: 378},
    {name: "Input Reference", number: 181},
    {name: "Instance Of", number: 48},
    {name: "Instantaneous Power", number: 379},
    {name: "Integral Constant", number: 49},
    {name: "Integral Constant Units", number: 50},
    {name: "Interval Offset", number: 195},
    {name: "Is Utc", number: 344},
    {name: "Key Sets", number: 330},
    {name: "Last Access Event", number: 275},
    {name: "Last Access Point", number: 276},
    {name: "Last Credential Added", number: 277},
    {name: "Last Credential Added Time", number: 278},
    {name: "Last Credential Removed", number: 279},
    {name: "Last Credential Removed Time", number: 280},
    {name: "Last Key Server", number: 331},
    {name: "Last Notify Record", number: 173},
    {name: "Last Priority", number: 369},
    {name: "Last Restart Reason", number: 196},
    {name: "Last Restore Time", number: 157},
    {name: "Last Use Time", number: 281},
    {name: "Life Safety Alarm Values", number: 166},
    {name: "Lighting Command", number: 380},
    {name: "Lighting Command Default Priority", number: 381},
    {name: "Limit Enable", number: 52},
    {name: "Limit Monitoring Interval", number: 182},
    {name: "List Of Group Members", number: 53},
    {name: "List Of Object Property References", number: 54},
    {name: "Local Date", number: 56},
    {name: "Local Forwarding Only", number: 360},
    {name: "Local Time", number: 57},
    {name: "Location", number: 58},
    {name: "Lock Status", number: 233},
    {name: "Lockout", number: 282},
    {name: "Lockout Relinquish Time", number: 283},
    {name: "Log Buffer", number: 131},
    {name: "Log Device Object Property", number: 132},
    {name: "Log Interval", number: 134},
    {name: "Logging Object", number: 183},
    {name: "Logging Record", number: 184},
    {name: "Logging Type", number: 197},
    {name: "Low Limit", number: 59},
    {name: "Maintenance Required", number: 158},
    {name: "Manipulated Variable Reference", number: 60},
    {name: "Manual Slave Address Binding", number: 170},
    {name: "Masked Alarm Values", number: 234},
    {name: "Maximum Output", number: 61},
    {name: "Maximum Value", number: 135},
    {name: "Maximum Value Timestamp", number: 149},
    {name: "Max Actual Value", number: 382},
    {name: "Max Apdu Length Accepted", number: 62},
    {name: "Max Failed Attempts", number: 285},
    {name: "Max Info Frames", number: 63},
    {name: "Max Master", number: 64},
    {name: "Max Pres Value", number: 65},
    {name: "Max Segments Accepted", number: 167},
    {name: "Member Of", number: 159},
    {name: "Member Status Flags", number: 347},
    {name: "Members", number: 286},
    {name: "Minimum Off Time", number: 66},
    {name: "Minimum On Time", number: 67},
    {name: "Minimum Output", number: 68},
    {name: "Minimum Value", number: 136},
    {name: "Minimum Value Timestamp", number: 150},
    {name: "Min Actual Value", number: 383},
    {name: "Min Pres Value", number: 69},
    {name: "Mode", number: 160},
    {name: "Model Name", number: 70},
    {name: "Modification Date", number: 71},
    {name: "Muster Point", number: 287},
    {name: "Negative Access Rules", number: 288},
    {name: "Network Access Security Policies", number: 332},
    {name: "Node Subtype", number: 207},
    {name: "Node Type", number: 208},
    {name: "Notification Class", number: 17},
    {name: "Notification Threshold", number: 137},
    {name: "Notify Type", number: 72},
    {name: "Number Of Apdu Retries", number: 73},
    {name: "Number Of Authentication Policies", number: 289},
    {name: "Number Of States", number: 74},
    {name: "Object Identifier", number: 75},
    {name: "Object List", number: 76},
    {name: "Object Name", number: 77},
    {name: "Object Property Reference", number: 78},
    {name: "Object Type", number: 79},
    {name: "Occupancy Count", number: 290},
    {name: "Occupancy Count Adjust", number: 291},
    {name: "Occupancy Count Enable", number: 292},
    {name: "Occupancy Lower Limit", number: 294},
    {name: "Occupancy Lower Limit Enforced", number: 295},
    {name: "Occupancy State", number: 296},
    {name: "Occupancy Upper Limit", number: 297},
    {name: "Occupancy Upper Limit Enforced", number: 298},
    {name: "Operation Expected", number: 161},
    {name: "Optional", number: 80},
    {name: "Out Of Service", number: 81},
    {name: "Output Units", number: 82},
    {name: "Packet Reorder Time", number: 333},
    {name: "Passback Mode", number: 300},
    {name: "Passback Timeout", number: 301},
    {name: "Polarity", number: 84},
    {name: "Port Filter", number: 363},
    {name: "Positive Access Rules", number: 302},
    {name: "Power", number: 384},
    {name: "Prescale", number: 185},
    {name: "Present Value", number: 85},
    {name: "Priority", number: 86},
    {name: "Priority Array", number: 87},
    {name: "Priority For Writing", number: 88},
    {name: "Process Identifier", number: 89},
    {name: "Process Identifier Filter", number: 361},
    {name: "Profile Name", number: 168},
    {name: "Program Change", number: 90},
    {name: "Program Location", number: 91},
    {name: "Program State", number: 92},
    {name: "Property List", number: 371},
    {name: "Proportional Constant", number: 93},
    {name: "Proportional Constant Units", number: 94},
    {name: "Protocol Object Types Supported", number: 96},
    {name: "Protocol Revision", number: 139},
    {name: "Protocol Services Supported", number: 97},
    {name: "Protocol Version", number: 98},
    {name: "Pulse Rate", number: 186},
    {name: "Read Only", number: 99},
    {name: "Reason For Disable", number: 303},
    {name: "Reason For Halt", number: 100},
    {name: "Recipient List", number: 102},
    {name: "Records Since Notification", number: 140},
    {name: "Record Count", number: 141},
    {name: "Reliability", number: 103},
    {name: "Reliability Evaluation Inhibit", number: 357},
    {name: "Relinquish Default", number: 104},
    {name: "Requested Shed Level", number: 218},
    {name: "Requested Update Interval", number: 348},
    {name: "Required", number: 105},
    {name: "Resolution", number: 106},
    {name: "Restart Notification Recipients", number: 202},
    {name: "Restore Completion Time", number: 340},
    {name: "Restore Preparation Time", number: 341},
    {name: "Scale", number: 187},
    {name: "Scale Factor", number: 188},
    {name: "Schedule Default", number: 174},
    {name: "Secured Status", number: 235},
    {name: "Security Pdu Timeout", number: 334},
    {name: "Security Time Window", number: 335},
    {name: "Segmentation Supported", number: 107},
    {name: "Serial Number", number: 372},
    {name: "Setpoint", number: 108},
    {name: "Setpoint Reference", number: 109},
    {name: "Setting", number: 162},
    {name: "Shed Duration", number: 219},
    {name: "Shed Level Descriptions", number: 220},
    {name: "Shed Levels", number: 221},
    {name: "Silenced", number: 163},
    {name: "Slave Address Binding", number: 171},
    {name: "Slave Proxy Enable", number: 172},
    {name: "Start Time", number: 142},
    {name: "State Description", number: 222},
    {name: "State Text", number: 110},
    {name: "Status Flags", number: 111},
    {name: "Stop Time", number: 143},
    {name: "Stop When Full", number: 144},
    {name: "Structured Object List", number: 209},
    {name: "Subordinate Annotations", number: 210},
    {name: "Subordinate List", number: 211},
    {name: "Subscribed Recipients", number: 362},
    {name: "Supported Formats", number: 304},
    {name: "Supported Format Classes", number: 305},
    {name: "Supported Security Algorithms", number: 336},
    {name: "System Status", number: 112},
    {name: "Threat Authority", number: 306},
    {name: "Threat Level", number: 307},
    {name: "Time Delay", number: 113},
    {name: "Time Delay Normal", number: 356},
    {name: "Time Of Active Time Reset", number: 114},
    {name: "Time Of Device Restart", number: 203},
    {name: "Time Of State Count Reset", number: 115},
    {name: "Time Synchronization Interval", number: 204},
    {name: "Time Synchronization Recipients", number: 116},
    {name: "Total Record Count", number: 145},
    {name: "Trace Flag", number: 308},
    {name: "Tracking Value", number: 164},
    {name: "Transaction Notification Class", number: 309},
    {name: "Transition", number: 385},
    {name: "Trigger", number: 205},
    {name: "Units", number: 117},
    {name: "Update Interval", number: 118},
    {name: "Update Key Set Timeout", number: 337},
    {name: "Update Time", number: 189},
    {name: "User External Identifier", number: 310},
    {name: "User Information Reference", number: 311},
    {name: "User Name", number: 317},
    {name: "User Type", number: 318},
    {name: "Uses Remaining", number: 319},
    {name: "Utc Offset", number: 119},
    {name: "Utc Time Synchronization Recipients", number: 206},
    {name: "Valid Samples", number: 146},
    {name: "Value Before Change", number: 190},
    {name: "Value Set", number: 191},
    {name: "Value Change Time", number: 192},
    {name: "Variance Value", number: 151},
    {name: "Vendor Identifier", number: 120},
    {name: "Vendor Name", number: 121},
    {name: "Verification Time", number: 326},
    {name: "Vt Classes Supported", number: 122},
    {name: "Weekly Schedule", number: 123},
    {name: "Window Interval", number: 147},
    {name: "Window Samples", number: 148},
    {name: "Write Status", number: 370},
    {name: "Zone From", number: 320},
    {name: "Zone Members", number: 165},
    {name: "Zone To", number: 321}
];

export class BacnetPropertyCollection extends BaseCollection<Backbone.Model> {
    url = null;

    initialize() {
        this.add(models);
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/BacnetProperties.ts